import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import shareFlowImage from "../../assests/images/dashboardImages/dashboardShareIcon1.webp"
import { Chart as ChartJS, ArcElement, Tooltip, Legend,CategoryScale } from "chart.js/auto";
import { Bar } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);


const ClientDashboard = () => {


    const option = {
        responsive: true,
        plugins: {
          legend: { position: "chartArea" },
          title: {
            display: true,
            text: "Modular Bar Chart",
          },
        },
      };

    //   labels:["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
      
      const data = {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
        datasets: [{
          label: 'My First Dataset',
          data: [65, 59, 80, 81, 56, 55, 40],
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 159, 64, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(201, 203, 207, 0.2)'
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
          ],
          borderWidth: 1,
          barThickness : 5
        }]
      };

    return (
        <div class="col-lg-12" >
            <h1 class="fs-4 w-100 border-bottom p-2">
                Dashboard
            </h1>
            <div class="container d-flex justify-content-around col-lg-12 mt-5">            
                 <div class="col-lg-3 d-flex flex-column text-center boxBackgroundStyle  border rounded">
                    <h1  class="colorPrimary fs-2 fw-bold">Total Shares</h1>
                    <h1 class="colorPrimary fs-2 fw-bold">500</h1>
                    <div class="align-self-end">
                        <img src={shareFlowImage} alt="total-shares" />
                    </div>
                 </div>
                <div class="col-lg-3 d-flex flex-column text-center boxBackgroundStyle border rounded">
                    <h1  class="colorPrimary fs-2 fw-bold">My Shares</h1>
                    <h1 class="colorPrimary fs-2 fw-bold">500</h1>
                    <div class="align-self-end">
                        <img src={shareFlowImage} alt="total-shares" />
                    </div>
                 </div>
                <div class="col-lg-3 d-flex flex-column text-center boxBackgroundStyle border rounded">
                    <h1  class="colorPrimary fs-2 fw-bold">Total Stores</h1>
                    <h1 class="colorPrimary fs-2 fw-bold">500</h1>
                    <div class="align-self-end">
                        <img src={shareFlowImage} alt="total-shares" />
                    </div>
                 </div>
            </div>
            {/* <div class="mx-2 graphSize">
            <Bar options={option} data={data} />
            </div> */}
          
    
        </div>
    )
}

export default ClientDashboard